<template>
  <a :href="href" :aria-label="provider">
    <img :src="asset" :srcset="asset2x" :alt="provider" />
  </a>
</template>
<script setup lang="ts">
interface Props {
  provider: 'facebook' | 'apple' | 'google' | 'tiktok';
}

const props = defineProps({
  provider: null
});

const {
  public: { apiBase },
} = useRuntimeConfig();

const asset = computed<string>(() => {
  return `/images/social/${props.provider}.png`;
});

const asset2x = computed<string>(() => {
  return `/images/social/${props.provider}@2x.png 2x`;
});

const href = computed(() => `${apiBase}/sso/auth/${props.provider}?appOS=web`);
</script>
<style lang="scss" scoped>
a {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 5.2rem;
  height: 5.2rem;
  transition: box-shadow 300ms $ease-out-quad, border 300ms $ease-out-quad,
    background-color 300ms $ease-in-quad;
  border: var(--stroke_thickness_l) solid var(--color_neutral_60);
  border-radius: 50%;
  background-color: var(--color_neutral_60);
  &:hover,
  &:focus {
    border: 0.2rem solid var(--color_neutral_60);
    border: var(--stroke_thickness_l) solid var(--color_primary);
    background-color: var(--color_neutral_25);
    box-shadow: rgb(0 0 0 / 6%) 0 2px 4px 0 inset, rgb(0 0 0 / 4%) 0 3px 5px;
  }
}
</style>
